import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../slice/authSlice";
import candidateReducer from "../slice/candidateSlice";
import optimizationReducer from "../slice/optimizationSlice";
import clientReducer from "../slice/clientSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    candidates: candidateReducer,
    optimizations: optimizationReducer,
    clients: clientReducer,
  },
});

export default store;